import React from "react";
import Button from "components/CustomButtons/Button.jsx";
import withStyles from "@material-ui/core/styles/withStyles";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import CustomInput from "components/CustomInput/CustomInput.jsx";
import Add from "@material-ui/icons/AddBox";
import { Grid, FormControl, InputLabel } from "@material-ui/core";
import { appHelpers } from "../../_helpers";
import { ProgressBar } from "../../utils/ProgressBar";
import { appConstants } from "../../_constants";
import AutocompleteSelect from "../../utils/AutocompleteSelect";

const styles = (theme) => ({
  container: {
    display: "flex",
    flexWrap: "wrap",
  },
  input: {
    marginTop: "0 !important",
  },
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200,
  },
  root: {
    flexGrow: 1,
  },
  paper: {
    padding: theme.spacing.unit * 2,
    textAlign: "center",
    color: theme.palette.text.secondary,
  },
  formRoot: {
    display: "flex",
    flexWrap: "wrap",
  },
  formControl: {
    margin: theme.spacing.unit,
    minWidth: 120,
    width: "100%",
  },
  selectEmpty: {
    marginTop: theme.spacing.unit * 2,
  },
  searchButton: {
    backgroundColor: " #66bb6a",
  },
  airlineSelect: { marginTop: "0px", width: "100%" },
});

const SettingsPanel = ({
  handleSubmit,
  airlineId,
  airportCode,
  airports,
  currencyOptions,
  currency,
  classes,
  progress,
  error,
  formError,
  handleChange,
  fullScreen,
  airlinesData,
  handleAdd,
  isOpen,
  handleClose,
  user,
  currentPSCRegionalCharge,
  currentPSCInternationalCharge,
  disabled,
  reactSelectChange,
}) => {

  return (
    <div className={classes.root}>
      <ProgressBar isActive={progress} />
      <Grid container spacing={24}>
        <Grid item md={4} xs={12}>
          <div>
            <p style={{ margin: "0", fontSize: "14px" }}>
              Current PSC Regional Charge :
            </p>
            <h4 style={{ margin: "0" }}>
              &#36;{" "}
              {typeof currentPSCRegionalCharge === "number"
                ? appHelpers.numberWithCommas(currentPSCRegionalCharge)
                : currentPSCRegionalCharge}
            </h4>
          </div>
        </Grid>
        <Grid item md={4} xs={12}>
          <div>
            <p style={{ margin: "0", fontSize: "14px" }}>
              Current PSC International Charge :
            </p>
            <h4 style={{ margin: "0" }}>
              &#36;{" "}
              {typeof currentPSCInternationalCharge === "number"
                ? appHelpers.numberWithCommas(currentPSCInternationalCharge)
                : currentPSCInternationalCharge}
            </h4>
          </div>
        </Grid>
        <Grid item md={4} xs={12}>
          <Button color="regional" onClick={handleAdd} autoFocus>
            <Add /> Add Minimum Re-order Level
          </Button>
        </Grid>
      </Grid>
      <Dialog
        fullScreen={fullScreen}
        open={isOpen}
        onClose={handleClose}
        aria-labelledby="responsive-dialog-title"
      >
        <DialogTitle
          id="responsive-dialog-title"
          style={{
            background: `linear-gradient(60deg, ${
              appConstants.REGIONAL_LIGHT_COLOR
            }, ${appConstants.REGIONAL_COLOR})`,
          }}
        >
          <span style={{ color: "white", textTransform: "uppercase" }}>
            Set Wallet Re-order Level
          </span>
        </DialogTitle>
        <DialogContent>
          <Grid container spacing={24}>
            <Grid item md={12} sm={12}>
              <FormControl className={classes.formControl}>
                <InputLabel shrink htmlFor="age-simple">
                  Select Airline
                </InputLabel>
                <AutocompleteSelect
                  options={airlinesData.map((option) => ({
                    value: option.AirlineId,
                    label: option.Airline,
                  }))}
                  selectedOption={airlineId}
                  handleSelectChange={(e, name) => reactSelectChange(e, name)}
                  // selectLabel={"Airlines"}
                  name={"airlineId"}
                  disabled={user.AppRole === appConstants.ROLES.AIRLINE}
                />
              </FormControl>
            </Grid>
            <Grid item md={12} sm={12}>
              <FormControl className={classes.formControl}>
                <InputLabel shrink htmlFor="age-simple">
                  Select Airport
                </InputLabel>
                <AutocompleteSelect
                  options={airports.map((option) => ({
                    value: option.Code,
                    label: option.Name,
                  }))}
                  selectedOption={airportCode}
                  handleSelectChange={(e, name) => reactSelectChange(e, name)}
                  // selectLabel={"Airports"}
                  disabled={
                    user.AppRole === appConstants.ROLES.AIRPORT_MANAGER ||
                    user.Location
                  }
                  name={"airportCode2"}
                />
              </FormControl>
            </Grid>
            <Grid item md={12} sm={12}>
              <FormControl className={classes.formControl}>
                <InputLabel shrink htmlFor="age-simple">
                  Select Currency
                </InputLabel>
                <AutocompleteSelect
                  options={currencyOptions.map((option) => ({
                    value: option.Id,
                    label: option.Name,
                  }))}
                  selectedOption={currency}
                  handleSelectChange={(e, name) => reactSelectChange(e, name)}
                  name={"currency"}
                />
              </FormControl>
            </Grid>
            <Grid item md={12} sm={12}>
              <CustomInput
                className={classes.input}
                required
                labelText="Amount"
                id="newToken"
                formControlProps={{
                  fullWidth: true,
                }}
                inputProps={{
                  name: "newToken",
                  type: "number",
                  onChange: handleChange,
                }}
              />
              {error && <span style={{ color: "red" }}>{formError}</span>}
              {/* </Paper> */}
            </Grid>
          </Grid>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="danger">
            Cancel
          </Button>
          <Button
            disabled={disabled}
            onClick={handleSubmit}
            color="regional"
            autoFocus
          >
            Save
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
};

export default withStyles(styles)(SettingsPanel);



// WEBPACK FOOTER //
// ./src/Regional-Views/Settings/settingsPanel.js